import * as DASHBOARDS from '../../stateManagement/dashboards/dashboards.constants';
import { Dashboard } from '../../models/';

/** LOAD */
export function loadDashboards() {
    return { type: DASHBOARDS.DASHBOARDS_LOAD };
}

export function loadDashboardsSuccess(data: Dashboard[]) {
    return { type: DASHBOARDS.DASHBOARDS_LOAD_SUCCESS, payload: data };
}

export function loadDashboardsError(error: any) {
    return { type: DASHBOARDS.DASHBOARDS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addDashboards(data: Dashboard[]) {
    return { type: DASHBOARDS.DASHBOARDS_ADD, payload: data };
}

export function addDashboardsSuccess(data: Dashboard[]) {
    return { type: DASHBOARDS.DASHBOARDS_ADD_SUCCESS, payload: data };
}

export function addDashboardsError(error: any) {
    return { type: DASHBOARDS.DASHBOARDS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateDashboards(data: Dashboard[]) {
    return { type: DASHBOARDS.DASHBOARDS_UPDATE, payload: data };
}

export function updateDashboardsSuccess(data: Dashboard[]) {
    return { type: DASHBOARDS.DASHBOARDS_UPDATE_SUCCESS, payload: data };
}

export function updateDashboardsError(error: any) {
    return { type: DASHBOARDS.DASHBOARDS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteDashboard(guid: string) {
    return { type: DASHBOARDS.DASHBOARD_DELETE, payload: guid };
}

export function deleteDashboards(guids: string[]) {
    return { type: DASHBOARDS.DASHBOARDS_DELETE, payload: guids };
}

export function deleteDashboardSuccess(data: Dashboard[]) {
    return { type: DASHBOARDS.DASHBOARD_DELETE_SUCCESS, payload: data };
}

export function deleteDashboardsSuccess(data: Dashboard[]) {
    return { type: DASHBOARDS.DASHBOARDS_DELETE_SUCCESS, payload: data };
}

export function deleteDashboardError(error: any) {
    return { type: DASHBOARDS.DASHBOARD_DELETE_ERROR, payload: error };
}

export function deleteDashboardsError(error: any) {
    return { type: DASHBOARDS.DASHBOARDS_DELETE_ERROR, payload: error };
}